/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueContextMenuModule } from '../../../../../../shared/ui/src/lib/components/sysque-context-menu';
import { FormsModule } from '@angular/forms';
import { SystemOperationsComponent } from './system-operations.component';



@NgModule({
  declarations: [SystemOperationsComponent],
  imports: [
    CommonModule,
    FormsModule,
    SysqueContextMenuModule
  ],
  exports: [SystemOperationsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SystemOperationsModule { }
